<mat-checkbox [formControl]="checkboxFilterControl" multiple labelPosition='after'
  (keydown.enter)="$event.preventDefault()">
  {{ label }}
</mat-checkbox>